import ErpLabelList from "./list";


if (document.body.getAttribute("data-current-path") === "erp/labels") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ErpLabelList();
    }
}